import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { loadNewComps } from './features/actions/loadNewComps.ts';
import { setCompSequence, setRentalCompSequence } from './features/orderSlice.ts';
import { CompPropertyDataState, RootState } from './types.ts';

const sortCompIds = (ids: string[], entities: RootState['propertyData']['entities']) =>
  [...ids].sort((idA, idB) => {
    const compA = (entities[idA] as CompPropertyDataState)?.compData;
    const compB = (entities[idB] as CompPropertyDataState)?.compData;

    if (!compA || !compB) return 0;

    const compTypeOrder = { aiv: 0, arv: 1, undefined: 2 };
    const compTypeA = compTypeOrder[compA.compType ?? 'undefined'];
    const compTypeB = compTypeOrder[compB.compType ?? 'undefined'];

    if (compTypeA !== compTypeB) {
      return compTypeA - compTypeB;
    }

    const statusOrder: Record<string, number> = {
      SettledSale: 0,
      Contract: 1,
      Active: 2,
    };
    const statusA = compA.editableData.transaction.status;
    const statusB = compB.editableData.transaction.status;
    const orderA = statusA ? (statusOrder[statusA] ?? 3) : 3;
    const orderB = statusB ? (statusOrder[statusB] ?? 3) : 3;

    return orderA - orderB;
  });

export const sortCompsMiddleware = createListenerMiddleware();

sortCompsMiddleware.startListening({
  matcher: isAnyOf(loadNewComps),
  effect: (_, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const { compSequence, rentalCompSequence } = state.order;
    const { entities } = state.propertyData;

    const sortedCompSequence = sortCompIds(compSequence, entities);
    const sortedRentalCompSequence = sortCompIds(rentalCompSequence, entities);

    if (JSON.stringify(sortedCompSequence) !== JSON.stringify(compSequence)) {
      listenerApi.dispatch(setCompSequence(sortedCompSequence));
    }
    if (JSON.stringify(sortedRentalCompSequence) !== JSON.stringify(rentalCompSequence)) {
      listenerApi.dispatch(setRentalCompSequence(sortedRentalCompSequence));
    }
  },
});
